import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireRound} from '@tisa-group/models';

@Injectable({
  providedIn: 'root',
})
export class RoundService implements CrudService<UmpireRound> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params: JsonApiParams): Observable<JsonApiResponse<UmpireRound[]>> {
    return this.http
      .get('/rounds', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireRound>> {
    return this.http
      .get(`/rounds/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/rounds/${id}`);
  }

  update(
    body: Partial<UmpireRound>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireRound>> {
    return this.http
      .patch(`/rounds/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireRound>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireRound>> {
    return this.http
      .post(`/rounds`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
